import React from 'react'
import { useEffect, useState } from 'react';
import HomeArea from '../components/HomeArea'
import hipladeTemplate from '../../common/template'
import secureLocalStorage from 'react-secure-storage'
import HomeAreaStudent from '../components/HomeAreaStudent'
import HomeAreaCoordinator from '../components/HomeAreaCoordinator'
import HomeAreaTeacher from '../components/HomeAreaTeacher'
import HomeAreaManager from '../components/HomeAreaManager'
import { Box, Typography } from '@mui/material'
import { useHomeStyles } from '../styles/home.styles'
import { useTranslation } from 'react-i18next'
import UsersService from '../../services/UsersService'

function Home() {
  const classes = useHomeStyles();
  const { t } = useTranslation()
  const [userName, setUserName] = useState('');

  useEffect(() => {
    // Carrega as informações do usuário ao montar o componente
    const auth_user_id = secureLocalStorage.getItem('id');
    UsersService.get(auth_user_id).then((response) => {
      // Pegando apenas o primeiro nome
      setUserName(response.data.name.split(' ')[0]);
    }).catch(() => {
      // Falha aqui só custa o primeiro nome na saudação: não vale um toast de erro em cima de quem acabou de logar.
    });
  }, []);

  let profile_id = secureLocalStorage.getItem('role')

  return (
    <Box sx={{ px: 5, pb: 5 }}>
      <Typography variant="h2" className={classes.message} sx={{ mb: 3 }}>
        {t("welcome_message")} {userName}!
      </Typography>
      {profile_id == 1 && <HomeArea />}
      {profile_id == 2 && <HomeAreaCoordinator />}
      {profile_id == 5 && <HomeAreaStudent />}
      {profile_id == 3 && <HomeAreaTeacher />}
      {profile_id == 6 && <HomeAreaManager />}
    </Box>
  )
}
export default hipladeTemplate(Home)
